import {
	Section,
	SectionHeading,
	TextRow,
	RoundedShape,
	HeroButton,
	ShippedContainer,
	FirstTextRow,
	SecondTextRow,
	ThirdTextRow,
	ShippedProducts,
	CustomSwiperSlide,
} from "./styles";

import RoundedShapeImg from "../../../../Assets/Images/Services/rounded-shape.webp";
import shippedArrow from "../../../../Assets/Images/Culture/contact-us-arrow.svg";

import { useMobileDetector } from "../../../../utils/customHooks";
import { Autoplay, FreeMode } from "swiper/modules";
import { Swiper } from "swiper/react";

const HeroSection = () => {
	const ismobile = useMobileDetector();

	const handleScroll = () => {
		const element = document.getElementById("shareVisionSection");
		if (!element) return;
		window.scroll({
			top: element.offsetTop,
			behavior: "smooth",
		});
	};

	return (
		<Section>
			<SectionHeading>
				<FirstTextRow>
						<div>
							<TextRow>Build Bold.</TextRow>
						</div>
				</FirstTextRow>

				{ismobile ? (
					<SecondTextRow>
						<div>
							<TextRow>Grow Fast.</TextRow>
						</div>
						<div>
							<TextRow>Join Spesna.</TextRow>
						</div>
					</SecondTextRow>
				) : (
					<SecondTextRow>
						<div>
							<TextRow>Grow Fast. Join Spesna</TextRow>
						</div>
					</SecondTextRow>
				)}
			</SectionHeading>
		</Section>
	);
};

export default HeroSection;
